module.exports = __webpack_public_path__ + "media/images/plans/ceremony/setplan-1-0599b6b00157ee9a3aa7f43c3d29e2e2.png";